import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "select-label d-flex align-items-center"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "select-wrapper position-relative" }
const _hoisted_4 = ["value", "data-testid"]
const _hoisted_5 = {
  value: "",
  disabled: "",
  selected: "",
  style: { color: 'inherit' }
}
const _hoisted_6 = ["value"]

import { computed, VNode } from 'vue';

import { InputVariant, IOptions } from '@/types';

interface Props {
  label?: string;
  placeholder?: string;
  labelIcon?: string | object | (() => VNode) | null;
  required?: boolean;
  variant?: InputVariant;
  modelValue?: string | number;
  options?: IOptions[];
  testId?: string;
}
export default /*@__PURE__*/_defineComponent({
  __name: 'Select',
  props: {
    label: { default: "" },
    placeholder: { default: "" },
    labelIcon: { type: [String, Object, Function, null], default: null },
    required: { type: Boolean, default: false },
    variant: { default: "primary" },
    modelValue: { default: "" },
    options: { default: () => [] },
    testId: { default: "select" }
  },
  setup(__props: any) {

;

const props = __props;

const variantClass = computed(() => props.variant ?? 'primary');
const backgroundStyle = computed(() => ({
  background:
    props.modelValue && ["primary", "admin"].includes(props.variant)
      ? "rgba(28, 86, 145, 0.05)"
      : "none",
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(['w-100', variantClass.value])
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(__props.label) + " ", 1),
          (__props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true),
          (__props.labelIcon)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.labelIcon), {
                key: 1,
                class: "ms-1"
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("select", _mergeProps({
        style: { ...backgroundStyle.value },
        value: __props.modelValue,
        onChange: _cache[0] || (_cache[0] = e => _ctx.$emit('update:modelValue', (e.target as HTMLSelectElement).value)),
        "data-testid": __props.testId
      }, _ctx.$attrs), [
        _createElementVNode("option", _hoisted_5, _toDisplayString(__props.placeholder), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item, index) => {
          return (_openBlock(), _createElementBlock("option", {
            key: index,
            value: item.value
          }, _toDisplayString(item.label), 9, _hoisted_6))
        }), 128))
      ], 16, _hoisted_4)
    ])
  ], 2))
}
}

})